import React from "react";
import { connect } from "react-redux";
import Axios from "Source/axiosPool";
import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        loggedUser: store.loggedUser
    }
})

class FieldProjectLead extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            searchIsLoading: false
        }

        _.map(["onOpen", "onRenderOption"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    onOpen() {
        const url = "api/user";
        const params = {
            isDeleted: 0,
            type: "teamLead"
        };

        this.setState({
            ...this.state,
            searchIsLoading: true
        });

        if( this.props.onLeadOpen ) {
            this.props.onLeadOpen();
        }

        Axios.get(url, params)
            .then(response => {
                if( response.data ) {
                    this.setState({
                        ...this.state,
                        searchIsLoading: false,
                        users: response.data.result.map(u => ({
                            value: u.id,
                            label: `${u.firstName} ${u.lastName}`
                        }))
                    });
                }
            });
    }

    onRenderOption(option) {
        return (
            <div class="lead-option">
                <div class="lead-container">
                    <Avatar id={option.value} name={option.label}  disableTooltip={true} />
                    <span>{option.label}</span>
                </div>
            </div>
        )
    }

    render() {
        const { loggedUser } = this.props;

        return (
            <div class="formSection">
                <div class="formContainer">
                    <label>Account Lead <sup>*</sup></label>
                    <Select 
                        isSearchable={true}
                        classes={{options: `addUsersOption accountLeadOption`}}
                        placeholder="Search"
                        options={this.state.users}
                        onChange={this.props.onSelectLead}
                        onClearSelected={this.props.onSelectLead}
                        onOpen={this.onOpen}
                        isLoading={this.state.searchIsLoading}
                        isClose={this.props.isClose}
                        selected={this.props.typeId.value === 3 ? { value: loggedUser.data.id, label: `${loggedUser.data.firstName} ${loggedUser.data.lastName}` } : this.props.selected}
                        count={10}
                        renderOption={this.onRenderOption}
                        renderSelected={this.onRenderOption}
                        disabled={this.props.typeId.value === 3}
                        isFirstItemSelected={false}
                        searchIcon={<i class="material-icons">search</i>}
                    />
                </div>
            </div>
        );
    }
}

export default FieldProjectLead;
